import { Typography, withStyles, TypographyProps } from '@material-ui/core';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { useTitleInViewAction } from './LegalProvider';
import { InView } from 'react-intersection-observer';

import { EmailComponent, FindLinkById, LinkText, TEXT_ID_BASE } from './StyledComponent';
import { useMemo } from 'react';

const DoubleMarginTypography = withStyles((theme) => ({
    root: { margin: theme.spacing(1), marginBottom: theme.spacing(3), color: '#FFF' }
}))(Typography);

export const ContentText = withStyles(() => ({
    root: {
        fontWeight: 300
    }
}))((props: TypographyProps) => <DoubleMarginTypography {...props} variant="body1" />);

export const LegalHeadlineText = withStyles((theme) => ({
    root: {
        fontWeight: 600,
        color: theme.palette.primary.light,
        borderBottom: `solid 1px ${theme.palette.primary.light}`,
        paddingBottom: theme.spacing(2)
    }
}))(Typography);

export const LegalTitleText = withStyles(() => ({
    root: {
        fontWeight: 600,
        color: '#FFF'
    }
}))((props: TypographyProps) => <Typography {...props} variant="h6" />);

export const LegalSubTitleText = withStyles(() => ({
    root: {
        fontWeight: 600,
        color: '#FFF'
    }
}))((props: TypographyProps) => <Typography {...props}  />);

export function renderCommonText(
    data: string | { key: string; href: string },
    withoutKey?: boolean
) {
    const key = withoutKey ? '' : 'legal:';
    if (typeof data === 'string') {
        return (
            <Trans
                key={data}
                i18nKey={`${key}${data}`}
                components={[
                    <ContentText />,
                    <strong />,
                    <LinkText href="" />,
                    <i />,
                    <EmailComponent />,
                    <FindLinkById />
                ]}
            />
        );
    }
    return (
        <Trans
            key={data.key}
            i18nKey={`${key}${data.key}`}
            components={[
                <ContentText />,
                <strong />,
                <LinkText href={data.href} />,
                <i />,
                <EmailComponent />,
                <FindLinkById />
            ]}
        />
    );
}
export function renderList(data: string) {
    const { t } = useTranslation('legal');
    return (
        <ul style={{ listStyleType: 'square', color: '#FFF' }}>
            {(t(data, {}, { returnObjects: true }) as any).map((key: string) => (
                <li key={key}>{renderCommonText(key, true)}</li>
            ))}
        </ul>
    );
}

export function renderTitle(index: number, hideShort?: boolean) {
    const { t } = useTranslation('legal');
    const setTitleInView = useTitleInViewAction();
    const title = useMemo(() => {
        return [index].map((i) => `${t('tableOfContents', {}, { returnObjects: true })[i]}`);
    }, [index]);
    return (
        <InView
            threshold={0.1}
            onChange={(isInView) => {
                if (!isInView) {
                    return;
                }

                if (isInView && index) setTitleInView(+index);
            }}>
            {({ ref }) => (
                <div ref={ref}>
                    <LegalTitleText
                        id={`${TEXT_ID_BASE}${index}`}>{`${index}. ${title}`}</LegalTitleText>
                    {!hideShort && renderCommonText(`termsSh${index}`)}
                </div>
            )}
        </InView>
    );
}

export function renderHeadline(index: number) {
    const { t } = useTranslation('legal');
    return (
        <LegalHeadlineText id={`${TEXT_ID_BASE}${index}`}>
            {[index].map((i) => t('tableOfContents', {}, { returnObjects: true })[i])}
        </LegalHeadlineText>
    );
}

export function renderAgreementList(key: string, index: number) {
    if (index === 2) {
        return (
            <li>
                {renderCommonText(key, true)}
                {renderList('mutL2')}
            </li>
        );
    }
    return <li>{renderCommonText(key, true)}</li>;
}
